import React, {useState, useEffect} from 'react';
import Dialog from '@mui/material/Dialog';
import * as firebaseui from 'firebaseui';
import BidmiiCustomLoader from '../../BidmiiCustomLoader/BidmiiCustomLoader';
import {
  fireSignUp,
  fireScreenView,
  SCREEN_NAMES,
} from '../../../util/Analytics';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import {theme} from '../../../Theme';
import CloseIcon from '@mui/icons-material/Close';
import useScreenWidth from '../../../hooks/useScreenWidth';
import {firebaseAuth} from '../../../App';

type LoginDialogProps = {
  onClose: $TSFixMeFunction;
  open: boolean;
  buttonPrompt?: string;
};

export default function LoginDialog(props: LoginDialogProps) {
  const width = useScreenWidth();
  useEffect(() => {
    if (props.open) {
      fireScreenView(SCREEN_NAMES.LOGIN_DIALOG);
    }
  }, [props.open]);

  const {onClose} = props;
  const [ui] = useState(
    firebaseui.auth.AuthUI.getInstance() ||
      new firebaseui.auth.AuthUI(firebaseAuth),
  );
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    onClose();
  };

  const signInOptions = [
    {
      provider: 'google.com',
      buttonColor: theme.palette.primary.main,
      fullLabel: 'Continue with Google',
    },
    {
      provider: 'facebook.com',
      buttonColor: theme.palette.primary.main,
      fullLabel: 'Continue with Facebook',
    },
    {
      provider: 'apple.com',
      buttonColor: theme.palette.primary.main,
      fullLabel: 'Continue with Apple',
    },
    {
      provider: 'password',
      buttonColor: theme.palette.primary.main,
      fullLabel: 'Continue with Email',
      requireDisplayName: false,
    },
  ];

  setInterval(() => {
    if (props.open) {
      const firebaseEls = document.getElementsByClassName(
        'firebaseui-link firebaseui-id-secondary-link',
      );
      const passwordEl = firebaseEls && firebaseEls[0];
      if (passwordEl) {
        passwordEl.innerHTML = 'Forgot password?';
        // @ts-expect-error
        passwordEl.style.position = 'relative';
        // @ts-expect-error
        passwordEl.style.bottom = '36px';
        // clearInterval(changeForgotPassword);
      }
    }
  }, 100);

  const startUi = (loginIndex: $TSFixMe) => {
    let signInSuccessUrl = window.location.pathname;
    if (window.location.search) {
      const searchParams = new URLSearchParams(window.location.search);
      const redirect = searchParams.get('redirect');
      if (redirect) {
        signInSuccessUrl = redirect;
      }
    }

    const checkContainer = setInterval(function () {
      if (document.getElementById('firebaseui-auth-container')) {
        ui.start('#firebaseui-auth-container', {
          callbacks: {
            signInSuccessWithAuthResult: function (authResult, redirectUrl) {
              setLoading(true);
              if (authResult.additionalUserInfo.isNewUser === true) {
                window.sessionStorage.setItem('isNewUser', '1');

                if (window.location.pathname === '/m/contractors') {
                  window.localStorage.setItem('userType', 'BIDDER');
                }

                fireSignUp(authResult.user);
              } else if (window.location.pathname !== signInSuccessUrl) {
                sessionStorage.setItem('signInSuccessUrl', signInSuccessUrl);
              }
              return false;
            },
          },
          tosUrl: 'https://www.bidmii.com/terms',
          privacyPolicyUrl: 'https://www.bidmii.com/privacy-policy',
          signInOptions: signInOptions,
          signInFlow: 'popup',
        });
        clearInterval(checkContainer);
      }
    }, 50);
  };

  useEffect(() => {
    if (props.open) {
      startUi(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.open]);

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={props.open}
      PaperProps={{
        style: {
          minWidth: 347,
          backgroundColor: loading && width > 600 ? 'transparent' : '#FFFFFF',
        },
        elevation: loading ? 0 : 2,
      }}
      fullScreen={width <= 600 || loading}>
      <>
        {width <= 600 && !loading && (
          <Grid container alignContent={'flex-end'} style={{height: 16}}>
            <IconButton
              onClick={props.onClose}
              style={{position: 'absolute', right: 8, top: 8}}
              size="large">
              <CloseIcon />
            </IconButton>
          </Grid>
        )}
        <div className="social-btn-group">
          <div
            id="firebaseui-auth-container"
            style={{minHeight: 300, marginTop: 60, maxWidth: '100vw'}}
          />
        </div>
      </>
      {loading && <BidmiiCustomLoader loading={loading} />}
    </Dialog>
  );
}
